import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CommonService } from "../../../services/CommonService";
import Datetime from "react-datetime";
import moment from "moment";
import { translateAndSortAscendant } from "../../../common/helper";
import Select from "../../../components/Select";

export default function ApplicationDetails({
  viewMode,
  applicationDetail,
  onChange,
  errors,
  managers,
  isOpen
}) {
  const RECOMENDED_CODE = "RC";
  const [candidateSources, setCandidateSources] = useState([]);
  const [candidateSourceRCIds, setCandidateSourceRCIds] = useState({});
  const [candidateSourceDFIds, setCandidateSourceDFIds] = useState({});
  const DF_CODE = "DF";
  const LI_CODE = "LI";
  const { t, i18n } = useTranslation();

  useEffect(() => {
    CommonService.getCandidateSources().then((data) => {
      setCandidateSources(translateAndSortAscendant(data, "description"));
      let _candidateSourceRCIds = {};
      data
        .filter((x) => x.code === RECOMENDED_CODE)
        .map((x) => x.id)
        .forEach((x) => (_candidateSourceRCIds[x] = true));
      setCandidateSourceRCIds(_candidateSourceRCIds);
    });
  }, []);

  useEffect(() => {
    CommonService.getCandidateSources().then((data) => {
      setCandidateSources(translateAndSortAscendant(data, "description"));
      let _candidateSourceDFIds = {};
      data
        .filter((x) => x.code === DF_CODE || x.code === LI_CODE)
        .map((x) => x.id)
        .forEach((x) => (_candidateSourceDFIds[x] = true));
      setCandidateSourceDFIds(_candidateSourceDFIds);
    });
  }, []);

  function onChangeAplicationDate(date) {
    if (moment(date).isValid())
      onChange({ target: { name: "date", value: date } });
  }
  
  function onChangeCaptureByMe({ target }) {
    onChange({ target: { name: "isCaptureByMe", value: target.checked } });
  }

  function onChangeSource({target}) {
    if(!candidateSourceDFIds[target.value]){
      onChange({ target: { name: "isCaptureByMe", value: false } });
    }
    onChange({ target: { name: target.name, value: target.value } });
  }

  return (
    <>
      <div className="row  mb-2">
        <div className="col ">
          <div className="label-wrapper">
            <label className="label">{t("Assign to")}</label>
            {errors.applicationDetailAssignUserId && (
              <span className="error-msg">
                {errors.applicationDetailAssignUserId}
              </span>
            )}
          </div>
          {!viewMode ? (
            <Select
              className="form-select"
              onChange={onChange}
              name="assignUserId"
              value={applicationDetail.assignUserId}
            >
              <option value="" selected disabled>
                {t("Select Item From List.")}
              </option>
              {managers.map((manager) => (
                <option value={manager.id} key={manager.id}>
                  {manager.nickname}
                </option>
              ))}
            </Select>
          ) : (
            <input
              className="form-control"
              value={applicationDetail.assignUser}
              disabled={viewMode}
            />
          )}
        </div>
        <div className="col">
          <div className="label-wrapper">
            <label className="label">{t("Apllication Date")}</label>
            {errors.applicationDetailDate && (
              <span className="error-msg">{errors.applicationDetailDate}</span>
            )}
          </div>
          <Datetime
            value={
              applicationDetail?.date &&
              moment(applicationDetail.date).format("DD-MM-yyyy")
            }
            name="applicationDate"
            dateFormat="DD-MM-YYYY"
            utc={true}
            timeFormat={false}
            closeOnSelect={true}
            onChange={onChangeAplicationDate}
            locale={
              118n.language === "PT"
                ? "PT"
                : i18n.language === "FR"
                ? "FR"
                : "EN"
            }
            inputProps={{
              placeholder: t("dd-mm-yyyy"),
              disabled: viewMode
            }}
          />
        </div>
        <div className="col">
          <div className="label-wrapper">
            {" "}
            <label className="label">{t("Source")}</label>
            {errors.applicationDetailSource && (
              <span className="error-msg">
                {errors.applicationDetailSource}
              </span>
            )}
          </div>
          {!viewMode ? (
            <Select
              className="form-select"
              value={applicationDetail?.candidateSourceId || ""}
              id="candidateSourceId"
              name="candidateSourceId"
              required
              title={t("Selecione um item da lista.")}
              onChange={onChangeSource}
            >
              <option value="" selected disabled>
                {t("Select Source...")}
              </option>
              {candidateSources.map((option) => (
                <option key={option.id} value={option.id}>
                  {t(option.description)}
                </option>
              ))}
            </Select>
          ) : (
            <input
              className="form-control"
              type="text"
              value={applicationDetail?.candidateSource}
              disabled={true}
            />
          )}
        </div>
        {applicationDetail?.isCaptureByMe && !isOpen && applicationDetail.createdUser != null && viewMode ? (
          <div className="col-2 ">
            <div className="label-wrapper">
              <label className="label">{t("Captured by?")}</label>
            </div>
            <div className="form-check form-switch">
              <input
                className="form-control"
                value={applicationDetail.createdUser}
                disabled={viewMode}
              />
            </div>
          </div>
        ) : (isOpen === true ? (
          <div className="col-md-2 field-width-captured">
            <div className="label-wrapper">
              <label className="label">{t("Captured by me?")}</label>
            </div>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="isCapturedByMe"
                name="isCapturedByMe"
                onChange={onChangeCaptureByMe}
                disabled={candidateSourceDFIds[applicationDetail?.candidateSourceId] ? false : true}
                checked={applicationDetail.isCapturedByMe}
                value={applicationDetail.isCaptureByMe}
              />
            </div>
          </div>
        ) : (applicationDetail.applicationDetailDate !== viewMode ? (
          <div className="col-2 " style={{display:"none"}}>
            <div className="label-wrapper">
              <label className="label">{t("Captured by?")}</label>
            </div>
          </div>
          ) : (
          <div className="col-md-2 field-width-captured">
            <div className="label-wrapper">
              <label className="label">{t("Captured by me ?")}</label>
            </div>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="isCapturedByMe"
                name="isCapturedByMe"
                onChange={onChangeCaptureByMe}
                disabled={candidateSourceDFIds[applicationDetail?.candidateSourceId] ? false : true}
                checked={applicationDetail.isCaptureByMe}
                value={applicationDetail.isCaptureByMe}
              />
            </div>
          </div>
        )))}
      </div>
      {((candidateSourceRCIds[applicationDetail.candidateSourceId] &&
        viewMode) ||
        !viewMode) && (
        <div className="row">
          <div className="col">
            <div className="form-group">
              <div className="label-wrapper">
                <label>{t("Recommended By Name")}</label>
              </div>
              <input
                name="recommendedName"
                type="text"
                value={applicationDetail?.recommendedName}
                placeholder={t("Name")}
                maxLength={100}
                disabled={
                  viewMode ||
                  !candidateSourceRCIds[applicationDetail.candidateSourceId]
                }
                onChange={onChange}
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <div className="label-wrapper">
                <label className="label">{t("Recommended By Email")}</label>
              </div>
              <input
                name="recommendedEmail"
                type="text"
                value={applicationDetail?.recommendedEmail}
                placeholder={t("Name")}
                maxLength={100}
                disabled={
                  viewMode ||
                  !candidateSourceRCIds[applicationDetail.candidateSourceId]
                }
                onChange={onChange}
              />
            </div>
          </div>
        </div>
      )}
      <div className="row">
        <div className="form-group">
          <div className="label-wrapper">
            <label className="label">{t("Notes")}</label>
          </div>
          <textarea
            className="form-control"
            value={applicationDetail?.notes}
            name="notes"
            onChange={onChange}
            disabled={viewMode}
            rows="3"
          ></textarea>
        </div>
      </div>
    </>
  );
}